import {ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import {ColumnMode} from '@almaobservatory/ngx-datatable';
import {Project, Publication} from 'asax-common';
import {DOCUMENT} from '@angular/common';


@Component({
  selector: 'asax-result-table-cell-similarity-for-observation',
  templateUrl: './cell-similarity-for-observation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CellSimilarityForObservationComponent {
  @Input() projects: Project[];
  @Input() publications: Publication[];
  @Output() onTabChanged = new EventEmitter<string>();

  ColumnMode = ColumnMode;

  constructor(@Inject(DOCUMENT) private readonly document: Document) {
  }

  ngOnInit() {
    this.onTabChanged.emit('projects');
  }

  buildUrlFilteringByProjectCode(projectCode: string): string {
    const projectCodeEncoded = encodeURIComponent(projectCode);
    return `${this.document.location.origin}${this.document.location.pathname}?result_view=projects&projectCode=${projectCodeEncoded}`;
  }

  onTabChange(tabId: string) {
    this.onTabChanged.emit(tabId);
  }
  
}
